module.exports = __webpack_public_path__ + "static/media/2.61936c13.jpg";